import React from "react";

const DisclaimerText = ({ children, className }) => (
  <p className={`font-mono font-light uppercase text-center leading-tight text-grey text-xs max-w-lg mx-auto ${className}`}>{children}</p>
)

export default DisclaimerText;